import React from 'react'
import PropTypes from 'prop-types'

import 'twin.macro'

const ArticleContainerHeading = ({ heading, subheading, avatarImage }) => (
  <div tw="container">
    <div tw="md:flex md:flex-wrap md:-mx-4 md:justify-start md:items-center w-full">
      {avatarImage ? (
        <div tw="md:flex-initial md:px-4 mb-4 md:mb-0">
          <div tw="w-16 h-16 md:w-24 md:h-24 rounded-full overflow-hidden">
            <img
              tw="w-full h-auto"
              className="lazyload"
              src={avatarImage.optimisedImages.placeholderBox}
              data-src={avatarImage.optimisedImages.src}
              data-srcset={avatarImage.optimisedImages.srcset}
              sizes="100vw"
              alt={avatarImage.altText}
            />
          </div>
        </div>
      ) : null}
      <div tw="md:px-4 overflow-hidden">
        {heading ? (
          <h1 tw="text-3xl md:text-4xl lg:text-5xl mb-1 md:mb-2">
            {heading.toLowerCase()}
          </h1>
        ) : null}
        {subheading ? (
          <h2 tw="text-xl md:text-2xl lg:text-3xl mb-0 text-brand-dark-grey">
            {subheading}
          </h2>
        ) : null}
      </div>
    </div>
  </div>
)

ArticleContainerHeading.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  avatarImage: PropTypes.shape({
    optimisedImages: PropTypes.object,
    altText: PropTypes.string,
    caption: PropTypes.string,
  }),
}

ArticleContainerHeading.defaultProps = {
  heading: '',
  subheading: '',
  avatarImage: null,
}

export default ArticleContainerHeading
